import { useContext } from "react";
import NodesContext from "contexts/NodesContext";
const useNodeSummaries = () => useContext(NodesContext);
export default useNodeSummaries;
